<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12" v-if="isContact">
            <h2 class="text-dag">{{ $t('menu_contact') }}</h2>
            <div class="receptdiv"><p class="sectiontitle2 text-muted">{{ $t('info_question') }}</p></div>
          </div>
          <div class="col-lg-12" v-else>
            <h2 class="text-dag">{{getContent.Title}}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">
              <div class="card-body p-t-25 p-b-30" v-html="getContent.Text">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getContent',
    ]),
    isContact () {
      return this.name === 'contact'
    }
  },
  methods: {
    ...mapActions([
      'loadContent',
    ]),
  },
  props: {
    name: ''
  },
  created() {
    this.loadContent(this.name)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/Content.vue